import { AccordionPanel, Box, Flex, Grid, Icon, SimpleGrid, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import { CotacaoFrete } from './components/Modais/CotacaoFrete'
import { ModalLayout } from './components/Modais/ModalLayout'
import { BsArrowsAngleExpand } from 'react-icons/bs'
import { CustomTooltip } from '../../../components/CustomTooltip'
import { FiPlusCircle } from 'react-icons/fi'
import { HiOutlineCube } from 'react-icons/hi'
import { ModalFotosItem } from './components/Modais/ModalFotosItem'
import { formatPrice } from '../../../utils/formatPrice'
import { ModalHistoricoLayout } from './components/Modais/ModalHistoricoLayout'
import { FormUpdateItem } from './FormUpdateItem'
import { UpdatePrecoVenda } from './UpdatePrecoVenda'
import { useMemo } from 'react'
import { SolicitarNegociacao } from './components/Modais/SolicitarNegociacao'
import { useOrcamentoPedido } from '../../../contexts/OrcamentoPedidoProvider'
import { Negociacao } from './components/Modais/Negociacao'
// import { ConfirmarEstoque } from './components/Modais/ConfirmarEstoque'

export function ExpandedItem({ item, nome_vendedor, num_proposta, cliente, email_parceiro, telefone_parceiro, codigo_vendedor, nome_parceiro }) {
  const { pedidoBloqueado } = useOrcamentoPedido()

  const valorTotal = useMemo(() => {
    return item.original_valor_total_itens + parseFloat(item.original_vlr_substituicao) + (parseFloat(item.transportadora?.valor_simulacao) || 0)
  }, [item.original_valor_total_itens, item.original_vlr_substituicao, item.transportadora?.valor_simulacao])

  // Convertendo valores para números (removendo formatação monetária se necessário)
  const precoSite =
    typeof item.preco_site === 'string' ? parseFloat(item.preco_site.replace(/[^\d,]/g, '').replace(',', '.')) : parseFloat(item.preco_site || 0)

  // Calculando o limite de negociação (preço site - 30%)
  const limiteNegociacao = precoSite * 0.7

  const calcularPorcentagemComissao = useMemo(() => {
    const COMISSAO_MINIMA = 0.8 // 0,8%
    const COMISSAO_MAXIMA = 3.0 // 3%

    const precoTabela =
      typeof item.preco_base === 'string' ? parseFloat(item.preco_base.replace(/[^\d,]/g, '').replace(',', '.')) : parseFloat(item.preco_base || 0)

    const precoVenda =
      typeof item.preco_site === 'string' ? parseFloat(item.preco_site.replace(/[^\d,]/g, '').replace(',', '.')) : parseFloat(item.preco_venda || 0)

    let porcentagemComissao

    if (precoVenda <= limiteNegociacao) {
      porcentagemComissao = COMISSAO_MINIMA
    } else if (precoVenda >= precoTabela) {
      porcentagemComissao = COMISSAO_MAXIMA
    } else {
      porcentagemComissao =
        COMISSAO_MINIMA + ((precoVenda - limiteNegociacao) * (COMISSAO_MAXIMA - COMISSAO_MINIMA)) / (precoTabela - limiteNegociacao)
    }

    return porcentagemComissao.toFixed(1)
  }, [item.preco_base, item.preco_venda, item.preco_site, limiteNegociacao])

  return (
    <AccordionPanel pb={0}>
      <Grid
        px="13px"
        pb="20px"
        pt={'5px'}
        fontSize="13px"
        alignItems="center"
        justifyContent="space-between"
        width="full"
        gridTemplateColumns="100px 1fr 1fr 1fr"
      >
        <Flex flexDir="column" gap="11px" mt="auto" position="relative">
          <ModalFotosItem images={item.imagens_produto} item={item} />
        </Flex>
        <FormUpdateItem
          item={item}
          cliente={cliente}
          email_parceiro={email_parceiro}
          telefone_parceiro={telefone_parceiro}
          codigo_vendedor={codigo_vendedor}
          nome_parceiro={nome_parceiro}
        />

        <Flex
          flexDir="column"
          alignItems="flex-start"
          justifyContent="space-between"
          borderRight="1px solid #CFCFCF"
          borderLeft="1px solid #CFCFCF"
          h="100%"
          px="17px"
        >
          <Text color="#378BBF" fontSize="15px" fontWeight="semibold" px={2}>
            Preço Item
          </Text>

          <SimpleGrid px={2} w="full" gridTemplateColumns={'1fr'} gap={5} fontSize="12px">
            <Flex h="29px" alignItems="center" justifyContent={'space-between'} minW="110px" flexShrink={0} fontSize="12px" mr={3}>
              <span>Preço site:</span>
              <Box>{item.preco_site}</Box>
            </Flex>
            {/* <Flex flex={1} h="29px" alignItems="center" fontSize="12px">
              <span>Limite negociação:</span>
              <Box ml={1}>{formatPrice(limiteNegociacao)}</Box>
            </Flex> */}
          </SimpleGrid>
          <Flex h="29px" alignItems="center" bgColor="#F5F5F5" w="full" gap={5} fontSize="12px" justifyContent="space-between" px={2}>
            <span> Preço de tabela:</span> {item.preco_base}
          </Flex>

          <UpdatePrecoVenda item={item} />

          <Flex h="29px" alignItems="center" bgColor="#F5F5F5" w="full" gap={5} fontSize="12px" justifyContent="space-between" px={2}>
            <Flex gap={2}>
              {' '}
              Comissão:{' '}
              {/* <Text color="red.500" fontWeight="bold" mr={1}>
                {calcularPorcentagemComissao}%
              </Text> */}
            </Flex>{' '}
            <Flex>({formatPrice(item.item_comissao)})</Flex>
          </Flex>
        </Flex>
        <Flex flexDir="column" alignItems="flex-start" justifyContent="space-between" pl="17px" h="100%">
          <Text color="#378BBF" fontSize="15px" fontWeight="semibold" px={2}>
            Total
          </Text>
          <Flex h="29px" alignItems="center" justifyContent="space-between" w="full" gap={5} px={2} fontSize="12px">
            <strong> Valor total do item:</strong> {item.valor_total_itens}
          </Flex>
          <Flex h="29px" alignItems="center" w="full" gap={5} fontSize="12px" justifyContent="space-between" px={2} bgColor="#F5F5F5">
            <strong>Substituição tributária:</strong> {item.vlr_substituicao}
          </Flex>
          <Flex h="29px" alignItems="center" justifyContent="space-between" w="full" gap={5} fontSize="12px" px={2}>
            <strong>Valor do frete:</strong> {item.transportadora?.valor_simulacao ? formatPrice(item.transportadora?.valor_simulacao) : 'R$ 0'}
          </Flex>
          <Flex h="29px" alignItems="center" bgColor="#F5F5F5" w="full" gap={5} fontSize="12px" justifyContent="space-between" px={2}>
            <strong>Valor total</strong>
            {formatPrice(valorTotal)}
          </Flex>

          <Flex gap={2} fontSize="12px">
            <Text maxW="240px" isTruncated>
              <Text as="span" color="#378BBF">
                Transportadora:
              </Text>{' '}
              {item.transportadora?.nome_transportadora || 'Não informado'}
            </Text>
            <Text>
              <Text as="span" color="#378BBF">
                Prazo:
              </Text>{' '}
              {item.transportadora?.prazo ? `${item.transportadora?.prazo} dias úteis` : 'Não informado'}
            </Text>
          </Flex>
        </Flex>
      </Grid>
      <Flex borderTop="1px dashed #CFCFCF" py="13px" justifyContent="space-between">
        <Flex gap={6}>
          <Flex color="#378bbf" alignItems="center" gap={2} pointerEvents="auto">
            <Icon as={HiOutlineCube} fontSize="25px" />

            <CustomTooltip
              label={
                <Text fontSize="13px" fontWeight="semibold" color="#378bbf">
                  + Cubagem
                </Text>
              }
            >
              <Table w="900px" borderCollapse="collapse" variant="unstyled">
                <Thead>
                  <Th textAlign="center" borderRight="1px solid #CFCFCF">
                    Qtd de Caixas
                  </Th>
                  <Th textAlign="center" borderRight="1px solid #CFCFCF">
                    Dimensões Caixa
                  </Th>
                  <Th textAlign="center" borderRight="1px solid #CFCFCF">
                    Qtd por Caixa
                  </Th>
                  <Th textAlign="center" borderRight="1px solid #CFCFCF">
                    Peso unitário
                  </Th>
                  <Th textAlign="center" borderRight="1px solid #CFCFCF">
                    Peso Aprox. Item
                  </Th>
                  <Th textAlign="center">Peso total</Th>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td textAlign="center" borderRight="1px solid #CFCFCF">
                      {item.cubagem.dimensoes.qtdcaixa}
                    </Td>
                    <Td textAlign="center" borderRight="1px solid #CFCFCF">
                      {item.cubagem.dimensoes.caixa}
                    </Td>
                    <Td textAlign="center" borderRight="1px solid #CFCFCF">
                      {item.cubagem.dimensoes.qtdporcaixa}
                    </Td>
                    <Td textAlign="center" borderRight="1px solid #CFCFCF">
                      {item.cubagem.dimensoes.pesocaixa}
                    </Td>
                    <Td textAlign="center" borderRight="1px solid #CFCFCF">
                      {parseFloat(item.cubagem?.peso_bruto).toFixed(2)}
                    </Td>

                    <Td textAlign="center">{item.cubagem.dimensoes.cubagemtotal}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </CustomTooltip>
          </Flex>
          <Flex color="#378bbf" alignItems="center" gap={2} pointerEvents="auto">
            <Icon as={FiPlusCircle} fontSize="25px" />
            <CustomTooltip
              label={
                <Text fontSize="13px" fontWeight="semibold" color="#378bbf">
                  Detalhes
                </Text>
              }
            >
              <Box w="400px">
                <strong>Descrição: </strong>
                {item.descricao_produto}
              </Box>
            </CustomTooltip>
          </Flex>
          <Flex color="#378bbf" alignItems="center" gap={2} pointerEvents="auto">
            <Icon as={BsArrowsAngleExpand} fontSize="16px" />
            <Text fontSize="13px" fontWeight="semibold">
              Dimensões: {item.cubagem.caixa}
            </Text>
          </Flex>
        </Flex>

        <Flex gap={2} pointerEvents={!pedidoBloqueado && 'auto'}>
          {/* <SolicitarAmostra item={item} /> */}

          <Negociacao item={item} />

          <SolicitarNegociacao item={item} nome_vendedor={nome_vendedor} codigo_vendedor={codigo_vendedor} />

          <ModalLayout item={item} nome_vendedor={nome_vendedor} num_proposta={num_proposta} codigo_parceiro={cliente.codigo_parceiro} />

          <ModalHistoricoLayout item={item} num_proposta={num_proposta} />

          <CotacaoFrete item={item} />
        </Flex>
      </Flex>
    </AccordionPanel>
  )
}
